import React, { useEffect, useState } from "react";
import { Button, Container, Row } from "react-bootstrap";
import "./ContactMe.css";
import emailjs from "emailjs-com";
import { ToastContainer, toast } from "react-toastify";

export default function ContactMe() {
  const [sendMessage, setSendMessage] = useState({
    success: "",
    error: "",
  });

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs.sendForm("gmail", "template_8vxogph", e.target, "user_auEKVrvX8G94uIrduhRRj").then(
      (result) => {
        setSendMessage({ ...sendMessage, success: "Send successfully" });
      },
      (error) => {
        setSendMessage({ ...sendMessage, error: "Sorry, Pls Try again. " });
      },

      e.target.reset()
    );
  };
  if (sendMessage.success) {
    if (sendMessage.success.length > 0) {
      toast.success(sendMessage.success, {
        hideProgressBar: true,
        autoClose: 5000,
      });
    }
  } else if (sendMessage.error) {
    if (sendMessage.error.length > 0) {
      toast.error(sendMessage.error, {
        hideProgressBar: true,
        autoClose: 5000,
      });
    }
  }

  useEffect(() => {
    if (sendMessage.success) {
      if (sendMessage.success.length > 0) {
        const timer = setTimeout(() => {
          setSendMessage({ ...sendMessage, success: "" });
        }, 5000);
        return () => clearTimeout(timer);
      }
    } else if (sendMessage.error) {
      if (sendMessage.error.length > 0) {
        const timer = setTimeout(() => {
          setSendMessage({ ...sendMessage, error: "" });
        }, 5000);
        return () => clearTimeout(timer);
      }
    }
  });

  return (
    <>
      <ToastContainer limit={1} />
      <div className="contactMe mt-5 mb-4" id="contact">
        <Container>
          <Row className="contactMeContainer">
            <div className="col-md-12 col-12 col-sm-12 pt-4 mb-5  text-center heading">
              <h6>
                <span>CONTACT ME</span>
              </h6>
            </div>
            <div className="col-md-12 col-12 col-sm-12 d-flex align-items-center justify-content-center contactContainer">
              <Row>
                <div data-aos="fade-right" className="col-md-6 col-12 col-sm-12 mb-5">
                  <p className="mb-3" style={{ fontSize: "1.5em" }}>
                    I will love to talk with. Send me email or DM me on my social media
                  </p>
                  <p>
                    Email : <a href="mailto: shihabunshakib9346@gmail.com">shihabunshakib9346@gmail.com</a>
                  </p>
                </div>
                <div data-aos="fade-left" className="col-md-6 col-12 col-sm-12 ">
                  <form onSubmit={sendEmail}>
                    <div className="form-group">
                      <label>Name</label>
                      <input required type="name" className="form-control nameInput" name="name" id="name" aria-describedby="nameHelp" placeholder="Enter name" />
                    </div>
                    <div className="form-group">
                      <label>Email address</label>
                      <input required type="email" className="form-control email" name="email" id="email" aria-describedby="emailHelp" placeholder="Enter email" />
                    </div>
                    <div className="form-group">
                      <label>Message</label>
                      <textarea required type="text" className="form-control message" name="message" id="message" aria-describedby="messageHelp" placeholder="Message" />
                    </div>

                    <Button type="submit" className="contactMe py-2 px-5">
                      SEND
                    </Button>
                  </form>
                </div>
              </Row>
            </div>
          </Row>
        </Container>
      </div>
    </>
  );
}
